<template>
  <v-navigation-drawer v-model="drawer" right fixed temporary>
    <v-list class="mt-6">
      <v-list-item
        active-class="primary--text font-weight-bold"
        class="subtitle-1"
        exact
        min-width="128"
        text
      >
        <v-list-item-content>
          <v-btn
            active-class="primary--text"
            class="subtitle-3 ml-1"
            exact
            min-width="128"
            text
            @click="onClickEmail"
          >
            <v-icon class="pr-3" color="primary">
              mdi-email-edit-outline
            </v-icon>
            <span>Написать</span>
          </v-btn>
          <v-btn
            active-class="primary--text"
            class="subtitle-3 ml-1"
            exact
            min-width="128"
            text
          >
            <v-icon class="pr-3" color="primary">
              mdi-phone
            </v-icon>
            <span @click="onClickTel">+7 (999) 555-52-28</span>
          </v-btn>
          <v-btn
            active-class="primary--text"
            class="subtitle-3 ml-1"
            exact
            min-width="128"
            text
          >
            <v-icon class="pr-3" color="primary">
              mdi-phone
            </v-icon>
            <span @click="onClickTel2">+7 (963) 770-37-63</span>
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="py-8">
        <v-img
          :src="require('@/assets/logo.svg')"
          class="mx-auto"
          max-width="128"
        />
      </div>
      <div class="text-center">
        <v-btn
          color="primary"
          class="ma-1"
          icon
          href="https://wa.me/79995555228"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          class="ma-1"
          icon
          href="https://www.instagram.com/5tu.ru/"
        >
          <v-icon>mdi-instagram</v-icon>
        </v-btn>

        <div class="my-3" />

        <div>
          Copyright &copy; {{ date }}&nbsp;<a href="https://ashtana.ru"
            >AShtana</a
          >
        </div>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "CoreDrawer",
  data: () => ({
    date: new Date().getFullYear()
  }),
  methods: {
    onClickTel() {
      window.open("tel:+79995555228", "_blank");
    },
    onClickTel2() {
      window.open("tel:+79637703763", "_blank");
    },
    onClickEmail() {
      window.open("mailto:zakaz-5tu.ru@yandex.ru", "_blank");
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("setDrawer", val);
      }
    }
  }
};
</script>
